import { ChangeDetectionStrategy, Component, inject, input, model, OnInit, output } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { Banco } from '../../banco-conta-convenio';
import { CommonModule } from '@angular/common';
import { CanDirective } from '@/core/permissions/can.directive';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-banco-detalhe',
    standalone: true,
    imports: [DialogoPadraoDirective, CommonModule, ReactiveFormsModule, ButtonModule, Dialog, InputTextModule, MessageModule, CanDirective],
    templateUrl: './banco-detalhe.html',
    styleUrl: './banco-detalhe.scss'
})
/** Modal de novo/edição de banco. */
export class BancoDetalhe implements OnInit {
    protected readonly roleBancosEditar = PERMISSOES.configuracoes.bancos.editar;

    private readonly fb = inject(FormBuilder);

    banco = input<Banco | null>(null);
    showDialog = model.required<boolean>();
    salvo = output<Banco>();

    bancoForm!: FormGroup<{ codigo: FormControl<string>; nome: FormControl<string> }>;
    formSubmitted = false;

    ngOnInit(): void {
        this.bancoForm = this.fb.nonNullable.group({
            codigo: ['', [Validators.required]],
            nome: ['', [Validators.required]]
        });
    }

    onDialogShow(): void {
        this.formSubmitted = false;
        const currentBanco = this.banco();
        if (currentBanco) {
            this.bancoForm.patchValue({
                codigo: currentBanco.codigo,
                nome: currentBanco.nome
            });
        } else {
            this.bancoForm.reset();
        }
    }

    hideDialog(): void {
        this.showDialog.set(false);
    }

    isInvalid(controlName: string): boolean {
        const control = this.bancoForm.get(controlName);
        return (control?.invalid && (control?.dirty || control?.touched || this.formSubmitted)) || false;
    }

    salvar(): void {
        this.formSubmitted = true;
        if (this.bancoForm.invalid) {
            return;
        }

        const formValue = this.bancoForm.getRawValue();
        const bancoSalvo: Banco = {
            ...(this.banco() || { id: '', usuario: '', descricao: '' }),
            codigo: formValue.codigo,
            nome: formValue.nome
        };

        this.salvo.emit(bancoSalvo);
        this.hideDialog();
    }
}
